import { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';

import { useCarousel } from 'src/common/providers/CarouselProvider';
import Button, { ButtonProps } from 'src/common/components/ButtonDS22';
import styles from './CarouselButtons.module.scss';

export type CarouselButtonsProps = {
  spacing: 'together' | 'apart';
  /** @param invisibleIfBothDisabled If both buttons are disabled, set visibility: hidden.
   * To remove without affecting layout */
  invisibleIfBothDisabled?: boolean;
} & Partial<Omit<ButtonProps, 'iconId'>>;

const CarouselButtons: FC<CarouselButtonsProps> = ({
  variant = 'tertiary',
  spacing = 'apart',
  invisibleIfBothDisabled,
  ...rest
}) => {
  const {
    scrollPrev,
    scrollNext,
    canScrollPrev,
    canScrollNext,
  } = useCarousel();

  return (
    <div className={getClassNames(
      styles,
      'root',
      classNames(
        spacing,
        { invisible: invisibleIfBothDisabled && !canScrollPrev && !canScrollNext },
      ),
    )}
    >
      <Button
        icon="caret-left"
        variant={variant}
        onClick={scrollPrev}
        aria-hidden={!canScrollPrev}
        disabled={!canScrollPrev}
        aria-label="Back"
        title="Back"
        {...rest}
      />
      <Button
        icon="caret-right"
        variant={variant}
        onClick={scrollNext}
        aria-hidden={!canScrollNext}
        disabled={!canScrollNext}
        aria-label="Next"
        title="Next"
        {...rest}
      />
    </div>
  );
};
export default CarouselButtons;
